import { config } from '../config/env';

export const PRODUCT_ID_PREFIX = 'gid://shopify/Product/';
export const VARIANT_ID_PREFIX = 'gid://shopify/ProductVariant/';
export const PRODUCT_PAGE_SIZE = 20;
export const PRODUCT_TYPE_1P = '1P';
export const PRODUCT_TYPE_3P = '3P';
export const RM3_COMPLEX_PROMOTION = 'RM3_COMPLEX_PROMOTION';
export const HORIZON_FONT_V2_CLASS_NAME = 'font-google-sans-v2';


export const CAROUSEL_TYPES = {
  HOME_RECOMMENDATIONS: 'homeRecommendation',
  TOP_PICKS: 'topPicks',
  SEARCH_START_TOP_PICKS: 'searchStartTopPicks',
  ADS_CAROUSEL: 'adsCarousel',
  FRESH_FOOD_CAROUSEL: 'freshRecommendations',
  SIMILAR_PRODUCTS: 'similarProducts',
  AGEING_RECOMMENDATIONS: 'ageingRecommendation',
  NEW_ARRIVALS_RECOMMENDATIONS: 'newlyOnboardedRecommendations',
  BASKET_RECOMMENDATION: 'basketRecommendation',
  BUY_AGAIN: 'buyAgain',
  SIMILAR_PRODUCT_FROM_SAME_BRAND: 'similarProductFromSameBrand',
  OTHER_SIMILAR_PRODUCT: 'otherSimilarProduct',
  MIGHT_ALSO_LIKE: 'mightAlsoLike',
  BRANDS: 'brand',
  CATEGORIES: 'category',
  BOUGHTTOGETHER: 'boughtTogether',
  HOME: 'home',
  TOPPICKS: 'topPicks',
  RECOMMENDED_FOR_YOU: 'recommended_for_you',
};

export const SOURCE_EVENTS = {
  PDP_RECOMMENDATIONS_CAROUSEL: 'pdpRecommendationsCarousel',
  BASKET_RECOMMENDATIONS_CAROUSEL: 'basketRecommendationsCarousel',
  PDP_BRAND_RECOMMENDATIONS_CAROUSEL: 'pdpBrandRecommendationsCarousel',
  BASKET_RECOMMENDATION_V2: 'basketRecommendationCarouselv2',
  BUY_AGAIN_RECOMMENDATION: 'homepageBuyAgainCarousel',
  HOME_PAGE_RECOMMENDED_FOR_YOU: 'homepageRecommendedForYouCarousel',
  HOME_PAGE_TOP_PICKS_RECOMMENDATIONS: 'homepageTopPicksForYouCarousel',
  SEARCH_START_TOP_PICKS_RECOMMENDATIONS: 'searchStartTopPicksForYouCarousel',
  FRESH_FOOD_RECOMMENDATIONS_CAROUSEL: 'freshRecommendations',
  AGEING_RECOMMENDATIONS: 'ageingRecommendations',
  NEW_ARRIVALS_RECOMMENDATIONS: 'newlyOnboardedRecommendations',
  PDP_BOUGHT_TOGETHER_CAROUSEL: 'pdpBoughtTogetherCarousel',
  ADS_CAROUSEL: 'plpAdsCarousel',
  PDP_CATEGORY_RECOMMENDATIONS_CAROUSEL: 'pdpCategoryRecommendationsCarousel',
  RECOMMENDATION_OI_BANNER: 'recommendationOIBanner',
};

export const BANNER_EVENTS = {
  IMPRESSION: 'bannerImpression',
  SLIDE: 'bannerSlide',
  CLICK: 'bannerClick',
} as const;

export const BANNER_TYPES = {
  TOP_BANNERS: 'top_banners',
} as const;

export const ANALYTICS_CHANNELS = {
  MKP_APP: 'mkp_app',
} as const;

export const PDP_RECOMMENDATION_TYPES = {
  BRAND: 'brand',
  CATEGORY: 'category',
};

export enum RecommendedType {
  PRODUCT_BASED = 'PRODUCT_BASED',
  USER_BASED = 'USER_BASED',
}
export enum ProductCardVariant {
  NORMAL = 'NORMAL',
  COMPACT = 'COMPACT',
  COMPACT_MINI = 'COMPACT_MINI',
}

export enum WEBVIEW_MESSAGE_TYPE {
  seeAll = 'SEE_ALL',
  navigatepdp = 'NAVIGATE_PDP_PAGE',
  requestFeatureFlags = 'REQUEST_FEATURE_FLAGS',
  filterApplied = 'FILTER_APPLIED',
  featureFlag = 'FEATURE_FLAG',
  iframeReady = 'IFRAME_READY',
  getUserDetails = 'GET_USER_DETAILS',
  heightChange = 'HEIGHT_CHANGE',
  basketItems = 'BASKET_ITEMS',
  sendRecommendations = 'SEND_RECOMMENDATIONS',
  searchRequest = 'SEARCH_REQUEST',
  carouselEmpty = 'CAROUSEL_EMPTY',
  carouselModel = 'CAROUSEL_MODEL',
  carouselImpression = 'CAROUSEL_IMPRESSION',
  carouselMaxItemCount = 'CAROUSEL_MAX_ITEM_COUNT',
  CAROUSEL_SCROLL = 'CAROUSEL_SCROLL',
  redirectToLogin = 'REDIRECT_TO_LOGIN',
  productCount = 'PRODUCT_COUNT',
  INITIAL_PRODUCTS = 'INITIAL_PRODUCTS',
  REFRESH_BASKET = 'REFRESH_BASKET',
  UPDATE_BASKET = 'UPDATE_BASKET',
  TRIGGER_BASKET_ANALYTICS = 'TRIGGER_BASKET_ANALYTICS',
  ADD_BASKET_ITEM_TO_LOCAL_STORAGE = 'ADD_BASKET_ITEM_TO_LOCAL_STORAGE',
  SHOW_PRODUCT_DETAILS_WEBVIEW_MESSAGE = 'SHOW_PRODUCT_DETAILS',
  APP_MODE = 'APP_MODE',
  REDIRECT_TO_APPLY_CARD = 'redirect_to_apply_card',
  REDIRECT_TO_PROMOTION_PLP = 'redirect_to_promotion_plp',
  TRIGGER_OPTION_SELECTOR_ANALYTICS = 'trigger_option_selector_analytics',
  SET_IFRAME_HEIGHT = 'set_iframe_height',
  HORIZON_PAGINATION_HEIGHT = 'horizon_pagination_height',
  HORIZON_BOTTOM_SHEET_STATE = 'horizon_bottom_sheet_state',
  TRIGGER_RECOMMENDATION_BANNER_ANALYTICS = 'trigger_recommendation_banner_analytics',
  NAVIGATE_RECOMMENDATION_BANNER = 'navigate_recommendation_banner',
  STORE_CODES = 'STORE_CODES',
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  USER_INFO = 'USER_INFO',
  IS_MFE_READY = 'IS_MFE_READY'
}

export const TitleKey = {
  TOP_PICKS_FOR_YOU: 'topPicksForYou',
  RECOMMENDED_FOR_YOU: 'recommendedForYou',
  SIMILAR_PRODUCTS: 'similarProducts',
  OTHER_SIMILAR_PRODUCTS: 'otherSimilarProducts',
  FREQUENTLY_BOUGHT_TOGETHER: 'boughtTogether',
  FRESH_FOOD_RECOMMENDATIONS: 'freshFood',
  HIGHLIGHTED_PRODUCTS: 'highlightedProducts',
};

export const ApiKey = {
  TOP_PICKS: 'TOP_PICKS',
  RECOMMENDED_FOR_YOU: 'RECOMMENDED_FOR_YOU',
  SIMILAR_PRODUCTS: 'SIMILAR_PRODUCTS',
  OTHER_SIMILAR_PRODUCTS: 'OTHER_SIMILAR_PRODUCTS',
  FREQUENTLY_BOUGHT_TOGETHER: 'FREQUENTLY_BOUGHT_TOGETHER',
  FRESH_FOOD_RECOMMENDATIONS: 'FRESH_FOOD_RECOMMENDATIONS',
  BASKET: 'BASKET',
};

export const SOURCE_EVENT_MAP = {
  [CAROUSEL_TYPES.TOP_PICKS]: SOURCE_EVENTS.HOME_PAGE_TOP_PICKS_RECOMMENDATIONS,
  [CAROUSEL_TYPES.SEARCH_START_TOP_PICKS]: SOURCE_EVENTS.SEARCH_START_TOP_PICKS_RECOMMENDATIONS,
  [CAROUSEL_TYPES.HOME_RECOMMENDATIONS]: SOURCE_EVENTS.HOME_PAGE_RECOMMENDED_FOR_YOU,
  [CAROUSEL_TYPES.BASKET_RECOMMENDATION]: SOURCE_EVENTS.BASKET_RECOMMENDATION_V2,
  [CAROUSEL_TYPES.FRESH_FOOD_CAROUSEL]: SOURCE_EVENTS.FRESH_FOOD_RECOMMENDATIONS_CAROUSEL,
  [CAROUSEL_TYPES.AGEING_RECOMMENDATIONS]: SOURCE_EVENTS.AGEING_RECOMMENDATIONS,
  [CAROUSEL_TYPES.NEW_ARRIVALS_RECOMMENDATIONS]: SOURCE_EVENTS.NEW_ARRIVALS_RECOMMENDATIONS,
  [CAROUSEL_TYPES.MIGHT_ALSO_LIKE]: SOURCE_EVENTS.PDP_RECOMMENDATIONS_CAROUSEL,
  [CAROUSEL_TYPES.ADS_CAROUSEL]: SOURCE_EVENTS.ADS_CAROUSEL,
  [CAROUSEL_TYPES.BOUGHTTOGETHER]: SOURCE_EVENTS.PDP_BOUGHT_TOGETHER_CAROUSEL,
  [CAROUSEL_TYPES.SIMILAR_PRODUCTS]: SOURCE_EVENTS.PDP_BRAND_RECOMMENDATIONS_CAROUSEL,
  [CAROUSEL_TYPES.BUY_AGAIN]: SOURCE_EVENTS.PDP_BRAND_RECOMMENDATIONS_CAROUSEL,
  [CAROUSEL_TYPES.BRANDS]: SOURCE_EVENTS.PDP_BRAND_RECOMMENDATIONS_CAROUSEL,
  [CAROUSEL_TYPES.CATEGORIES]: SOURCE_EVENTS.PDP_CATEGORY_RECOMMENDATIONS_CAROUSEL,
};

export enum RecommendationVariants {
  RECOMMENDED_FOR_YOU = 'RECOMMENDED_FOR_YOU',
  BASKET = 'BASKET',
  TOP_PICKS = 'TOP_PICKS',
  FREQUENTLY_BOUGHT_TOGETHER = 'FREQUENTLY_BOUGHT_TOGETHER',
  FRESH_FOOD = 'FRESH_FOOD',
  BUY_AGAIN = 'BUY_AGAIN',
}

export const FRESH_FOOD_FILTER = 'tags:[skuCode:fresh]';

export const DEFAULT_RECOMMENDATION_SEE_ALL_THRESHOLD = 10;
export const isStorePickupRecommendationFlagEnabled = config.STORE_PICKUP_RECOMMENDATIONS_ENABLED;
export const FALLBACK_APP_VERSION = '1.0.0';

export const URL_CONSTANTS = {
  PRODUCT_BASED: '/recommendations/PRODUCT_BASED/',
  USER_BASED: '/recommendations/USER_BASED/',
  SEARCH_BASED: '/recommendations/api/v1/search/document',
};

export const defaultSearchRequest = {
  q: '',
  page: 1,
  size: 20,
};

export enum AppMode {
  regular = 'regular',
  express = 'express',
  storePickup = 'store_pickup',
}
